import './LandingPage.css';

export default function LandingPage() {
    return (
        <main className='banner'>
            <section>
                <h2>Teaching personal finance?...</h2>
                <h3>We got you covered!</h3>
            </section>
        </main>
    )
}